import Immutable from 'immutable'
import moment from 'moment'

import createStorableCard from './StorableCard'

export const PaymentRecord = Immutable.Record({
  amount: null,
  card: null,
  clientId: null,
  dateAdded: null,
  dateUpdated: null,
  id: null,
  paymentDate: null,
  reference: '',
  success: false,
  token: null,
}, 'Payment')

export default function createPayment({
  amount,
  card,
  dateAdded,
  dateUpdated,
  paymentDate,
  token,
  ...data
}) {
  return new PaymentRecord({
    ...data,
    amount: parseFloat(amount),
    card: card ? createStorableCard(card) : null,
    dateAdded: dateAdded ? moment(dateAdded) : null,
    dateUpdated: dateUpdated ? moment(dateUpdated) : null,
    paymentDate: paymentDate ? moment(paymentDate) : null,
    token: token ? token.uuid : null,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Payment.js